/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

/**
 * CompleteyourBedProtector Input Action
 */
export class CompleteyourBedProtectorInput implements Msdyn365.IActionInput {
    public protector: SimpleProduct | undefined | null;
    // Construct the input needed to run the action
    constructor(protector: SimpleProduct | undefined | null) {
        this.protector = protector;
    }

    // Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CompleteyourBedProtector`;
    public getCacheObjectType = () => 'CompleteyourBedProtector';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// Create a data model here or import one to capture the response of the action
export interface ICompleteYourBedProtectorData {
    protector: SimpleProduct | undefined | null;
}

/**
 * Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext<ICompleteYourBedProtectorData>): Msdyn365.IActionInput => {
    return new CompleteyourBedProtectorInput(args?.config?.protector);
};

/**
 * Use this function to call your action and process the results as needed
 */
async function action(input: CompleteyourBedProtectorInput, ctx: Msdyn365.IActionContext): Promise<ICompleteYourBedProtectorData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<ISelectYourFoundationData[]>('/get/example/id/1', 'get');
    return { protector: input.protector };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICompleteYourBedProtectorData>>action,
    // Give your data action a unique id
    id: 'CompleteyourBedProtector',
    input: createInput
    // Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
